module.exports = __webpack_public_path__ + "img/repair_flow.9b71e3c5.png";